import {computed, Injectable, signal} from '@angular/core';
import {EmergencyOverviewColumn, EMERGENCY_OVERVIEW_COLUMNS} from './emergency-overview-column.config';

@Injectable({providedIn: 'root'})
export class EmergencyOverviewColumnService {
  readonly columns = signal<EmergencyOverviewColumn[]>(EMERGENCY_OVERVIEW_COLUMNS);

  readonly visibleColumns = computed(() => this.columns().filter(col => col.visible));

  /** CSS grid-template-columns value derived from visible columns */
  readonly gridTemplateColumns = computed(() =>
    this.visibleColumns().map(col => col.width).join(' ')
  );

  setColumnVisible(field: string, visible: boolean): void {
    this.columns.update(cols =>
      cols.map(col => col.field === field ? {...col, visible} : col)
    );
  }

  setColumnWidth(field: string, width: string): void {
    this.columns.update(cols =>
      cols.map(col => col.field === field ? {...col, width} : col)
    );
  }
}
